import { useRouter } from "next/router";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { BoothTwoTone } from "@/components/icons/booth-two-tone";
import SyncedListNotice from "@/components/import-list/synced-list-notice-component";

type SyncedSponsorsSettingsProps = {
  minimal?: boolean;
};

export default function SyncedSponsorsSettings({
  minimal = false,
}: SyncedSponsorsSettingsProps) {
  const { t } = useTranslation();
  const { query } = useRouter();
  const slug = query.slug as string;

  return (
    <SyncedListNotice
      title={t("preference-panel.block-display-name.booths-synced")}
      icon={BoothTwoTone}
      path="vendors"
      eventSlug={slug}
      minimal={minimal}
    >
      {t("preference-panel.expo.embedded-expo-synced")}
    </SyncedListNotice>
  );
}
